
<template>
    <div>
        <mars-view class="settlement"><top-bar :title="topBar.title" :bg-color="topBar.topBgColor" :text-color="topBar.fontColor" :no-blank="true"></top-bar><mars-image mode="widthFix" :preview="false" class="settlement-img" src="https://wyw-pic.cdn.bcebos.com/91ef76c6a7efce1b06061d58bd51f3deb48f6577?x-bce-process=image/quality,q_80" :lazy-load="true" @load="imageLoaded"></mars-image><mars-view v-if="!showLoading" class="holder"></mars-view><mars-view class="btn-wrapper"><mars-view class="close" @click.native="switchFeedback">暂不购买</mars-view><mars-view class="go-vip" @click.native="userBuy">我要购买</mars-view></mars-view><model v-if="isShowModel" :info="modelText" @closeModel="close"></model><mars-view v-if="isShowFeedback" class="input-mark"><mars-view class="input-model-wrapper"><mars-view class="input-title">
                请留下您的宝贵意见
                <mars-view class="icon iconfont input-title-close" @click.native="switchFeedback"></mars-view></mars-view><mars-view class="input-sub-title">帮助我们做的更好的服务法律行业</mars-view><mars-view class="input-content"><mars-textarea class="input-content-item" placeholder="请填写您的意见" @input="bindTextInput"></mars-textarea></mars-view><mars-view class="line"></mars-view><mars-view :class="editTextValue.length ? 'input-btn input-btn-focus' : 'input-btn'" @click.native="submitAdvise">提交</mars-view></mars-view></mars-view><c-loading v-if="showLoading" class="loading"></c-loading></mars-view>
    </div>
</template>

<script>
import Topbar from "../../components/common/topbar.vue";
import Model from "../../components/common/model.vue";
import { getData, request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import { act } from '../../static/utils/navigate.js';
import Loading from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Loading/Loading.vue";
import { ubcClickInit, ubcPvInit } from '../../static/utils/ubcMethods.js';
export default {
  components: {
    'top-bar': Topbar,
    'model': Model,
    'c-loading': Loading
  },
  methods: {
    copyLink() {
      this.$api.setClipboardData({
        data: 'lvlin.baidu.com/mp',
        success: () => {
          this.$api.showToast({
            title: '复制成功~',
            icon: 'none'
          });
        }
      });
    },
    switchFeedback() {
      this.isShowFeedback = !this.isShowFeedback;
    },
    close() {
      this.isShowModel = false;
    },
    userBuy() {
      ubcClickInit({
        page: this.pageName,
        from: 'index',
        value: 'user-buy',
        ctx: this.ctx
      });
      if (this.isLocking) {
        return;
      }
      this.isLocking = true;
      request({
        url: reqPathTo('agreeupgradepage', {}, '', 'law/sync'),
        data: this.ctx
      }).then(res => {
        this.isLocking = false;
        const data = res && res.data;
        if (+data.status === 0) {
          this.modelText.content = data.data.txt;
          this.isShowModel = true;
          ubcClickInit({
            page: this.pageName,
            from: 'index',
            value: 'user-buy-request-sccess',
            ext: {
              ...data.data,
              ...this.ctx
            }
          });
        } else {
          this.$api.showToast({
            title: '请求失败，请稍候重试',
            icon: 'none'
          });
          ubcClickInit({
            page: this.pageName,
            from: 'index',
            value: 'user-buy-request-error',
            ext: {
              ...data.data,
              ...this.ctx
            }
          });
        }
      }).catch(err => {
        this.$api.showToast({
          title: '请求失败，请稍候重试',
          icon: 'none'
        });
        this.isLocking = false;
        ubcClickInit({
          page: this.pageName,
          from: 'index',
          value: 'request-error',
          ext: err
        });
      });
    },
    imageLoaded() {
      this.showLoading = false;
    },
    submitAdvise() {
      if (!this.editTextValue) {
        this.$api.showToast({
          title: '意见不能为空',
          icon: 'none'
        });
        return;
      }
      if (this.isLocking) {
        return;
      }
      this.isLocking = true;
      ubcClickInit({
        page: this.pageName,
        from: 'index',
        value: 'user-advise-send',
        ext: {
          advise: this.editTextValue,
          ...this.ctx
        }
      });
      request({
        url: reqPathTo('lawyeradvisesave', {}, '', 'law/sync'),
        data: {
          advise: this.editTextValue,
          ...this.ctx
        }
      }).then(res => {
        this.isLocking = false;
        const data = res && res.data;
        if (+data.status === 0) {
          this.$api.showToast({
            title: '提交成功',
            icon: 'none'
          });
          ubcClickInit({
            page: this.pageName,
            from: 'index',
            value: 'user-advise-request-sccess',
            ext: {
              advise: this.editTextValue,
              ...this.ctx
            }
          });
        } else {
          this.$api.showToast({
            title: '提交失败，请重试',
            icon: 'none'
          });
          ubcClickInit({
            page: this.pageName,
            from: 'index',
            value: 'user-advise-request-error',
            ext: {
              advise: this.editTextValue,
              ...this.ctx
            }
          });
        }
        this.isShowFeedback = false;
      }).catch(err => {
        this.isShowFeedback = false;
        this.$api.showToast({
          title: '提交失败，请重试',
          icon: 'none'
        });
        ubcClickInit({
          page: this.pageName,
          from: 'index',
          value: 'request-error',
          ext: {
            err
          }
        });
      });
    },
    bindTextInput(e) {
      this.editTextValue = e.detail.value;
    }
  },
  data() {
    return {
      pageName: 'vipinterests/upgrade',
      topBar: {
        fontColor: '#000',
        title: '百度律临 律师会员',
        topBgColor: '#fff'
      },
      modelText: {
        title: '温馨提示',
        content: '',
        btnText: '确认'
      },
      isShowModel: false,
      isShowFeedback: false,
      isLogin: 0,
      showLoading: true,
      editTextValue: '',
      ctx: {}
    };
  },
  created() {
    (function (ctx) {
      this.ctx = ctx;
      try {
        let bodyStyle = document.body.style;
        // 重置body宽度
        bodyStyle.paddingBottom = '0';
      } catch (error) {}
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      ubcPvInit({
        page: this.pageName,
        from: 'index',
        value: 'upgrade-pv',
        ctx: this.ctx
      });
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.settlement {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.settlement .settlement-img {
  width: 100%;
  display: block;
}
.settlement .holder {
  width: 100%;
  height: 0.86rem;
  background: #191b20;
}
.settlement .btn-wrapper {
  width: 100%;
  height: 0.86rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #171a1f;
  padding: 0 4.106vw;
  box-sizing: border-box;
}
.settlement .btn-wrapper .close {
  flex: 1;
  height: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #f1d896;
  background-color: transparent;
  box-sizing: border-box;
  border: 1px solid #e5c07c;
  border-radius: 0.22rem;
  margin-right: 0.15rem;
}
.settlement .btn-wrapper .go-vip {
  flex: 1;
  height: 0.44rem;
  background-image: linear-gradient(90deg, #f4e6c5 2%, #e2b96f 100%);
  border-radius: 0.22rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #543500;
}
.input-mark {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.input-model-wrapper {
  width: 100%;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 0.21rem 0.21rem 0px 0px;
  padding-bottom: 0.2rem;
  position: absolute;
  bottom: -0.08rem;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}
.input-model-wrapper .input-title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1f1f1f;
  line-height: 1;
  text-align: center;
  padding-top: 0.18rem;
  position: relative;
}
.input-model-wrapper .input-title .input-title-close {
  width: 0.21rem;
  height: 0.21rem;
  position: absolute;
  top: 16px;
  right: 0.18rem;
  padding: 4px;
  box-sizing: border-box;
}
.input-model-wrapper .input-sub-title {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  line-height: 1;
  color: #858585;
  text-align: center;
  margin: 4.589vw auto 0;
}
.input-model-wrapper .input-content {
  width: 3.8rem;
  height: 0.82rem;
  text-align: center;
  margin: 0.17rem auto 0;
  padding: 0.12rem 0.14rem;
  box-sizing: border-box;
  border-radius: 2.174vw;
  background: #fff;
  position: relative;
}
.input-model-wrapper .input-content .input-content-item {
  width: 100%;
  height: 100%;
  line-height: 0.18rem;
  outline: none;
  border: none;
  font-size: 0.14rem;
}
.input-model-wrapper .input-content::after {
  content: " ";
  position: absolute;
  width: 3.812rem;
  height: 0.832rem;
  background: rgba(31, 31, 31, 0.15);
  border-radius: 2.174vw;
  box-sizing: border-box;
  color: #d9d9d9;
  top: -0.005rem;
  left: -0.006rem;
  z-index: -1;
}
.input-model-wrapper .line {
  width: 100%;
  height: 0.18vw;
  background: #e6e6e6;
  margin: 2.899vw 0;
}
.input-model-wrapper .input-btn {
  width: 91.787vw;
  height: 0.44rem;
  background: #4e6ef2;
  opacity: 0.3;
  border-radius: 0.22rem;
  font-family: PingFangSC-Medium;
  font-size: 3.865vw;
  color: #fff;
  text-align: center;
  line-height: 0.44rem;
  margin: 0 auto;
}
.input-model-wrapper .input-btn-focus {
  opacity: 1;
}

</style>
